/**
 * Backup/restore API client (P3-F Doc 41).
 */
import { api } from "./client";

export type RestoreMode = "overwrite" | "skip" | "rename";

export interface BundleEnvelope {
  version: string;
  bundle_type: "forms" | "workflows" | "all";
  exported_at: string;
  exported_by: string;
  tenant_id: string;
  items_count: number;
  items: Array<Record<string, unknown>>;
  checksum_sha256: string;
}

export interface ImportItemResult {
  code: string;
  action: "created" | "overwritten" | "skipped" | "renamed" | "error";
  new_code?: string | null;
  error?: string | null;
}

export interface ImportResponse {
  bundle_type: string;
  items_total: number;
  items_created: number;
  items_overwritten: number;
  items_skipped: number;
  items_renamed: number;
  items_failed: number;
  items: ImportItemResult[];
}

export const backupApi = {
  exportForms: () =>
    api.get<BundleEnvelope>("/api/v1/admin/backup/forms"),
  exportWorkflows: () =>
    api.get<BundleEnvelope>("/api/v1/admin/backup/workflows"),

  importForms: (
    bundle: Record<string, unknown>,
    mode: RestoreMode = "skip",
    verifyChecksum = true,
  ) =>
    api.post<ImportResponse>("/api/v1/admin/backup/import-forms", {
      bundle,
      mode,
      verify_checksum: verifyChecksum,
    }),

  importWorkflows: (
    bundle: Record<string, unknown>,
    mode: RestoreMode = "skip",
    verifyChecksum = true,
  ) =>
    api.post<ImportResponse>("/api/v1/admin/backup/import-workflows", {
      bundle,
      mode,
      verify_checksum: verifyChecksum,
    }),
};

/** Helper: trigger browser download của bundle JSON. */
export function downloadBundleAsFile(
  bundle: BundleEnvelope,
  filename: string,
): void {
  const blob = new Blob([JSON.stringify(bundle, null, 2)], {
    type: "application/json",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
